// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"838ac588","90":"9a86bb13","168":"ecb151ae","252":"fa7b3d8e","278":"62e58e84","286":"2dd3061a","322":"e949c4a5","428":"ac6cc33b","512":"8d0369f0","603":"115fb09b","756":"a82792c1","801":"957a8ffd","816":"efffa50f"}[chunkId] + ".chunk.js";
};